module.exports = __webpack_public_path__ + "static/media/menu-team-icon.05c10f7a.svg";